module.exports = __webpack_public_path__ + "dlssrvtline2/img/th-slider-4.jpg?684169f8";